import {required, minLength8, phoneValidation} from '../../validations/Validatiors';
export const ValidationRules = [
    {
        field: 'password',
        method: required,
        message: 'Please enter your current password.'
    },
    {
        field: 'new_password',
        method: required,
        message: 'Please enter a new password.'
    },
    {
        field: 'new_password',
        method: minLength8,
        message: 'New Password must be minimum 8 character long.'
    },
    {
        field: 'confirm_password',
        method: required,
        message: 'Please confirm new password.'
    },
    {
        field: 'search_string',
        method: required,
        message: 'Please enter search string.'
    },
    {
        field: 'first_name',
        method: required,
        message: 'Please enter first name.'
    },
    {
        field: 'last_name',
        method: required,
        message: 'Please enter last name.'
    },
    {
        field: 'phone',
        method: phoneValidation,
        message: 'Please enter a valid phone number.'
    }
];


// WEBPACK FOOTER //
// ./src/components/staffDashboard/ValidationRules.js